<div *ngIf="!showSuccessfulRegistrationForm" [ngStyle]="formStyle">
    <h2>
        Self-Register
        <naming-convention-label [type]="'EndUser'" [singular]="true"></naming-convention-label>
        <form-state></form-state>
    </h2>
    <form [formGroup]="playerForm" (ngSubmit)="createPlayer()">
        <p-fieldset legend="Reason Of Attendance" *ngIf="noSelfRegUrlAvailable">
            <div class="grid p-fluid">
                <div class="col-6">
                    <div class="inputs-group">
                        <div class="inputs-group-row">
                            <div class="inputs-group-row-value">
                                <textarea
                                    formControlName="participationReason"
                                    style="resize: none"
                                    pInputTextarea
                                    id="participationReason"
                                    [rows]="2"
                                    [cols]="50"
                                    maxlength="100">
                                </textarea>
                                <control-errors [control]="playerForm.get('participationReason')"></control-errors>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </p-fieldset>

        <p-fieldset legend="BASIC INFO">
            <div class="grid p-fluid">
                <div class="col-6">
                    <m-control-group [required]="true" label="Title">
                        <m-title-control formControlName="title"></m-title-control>
                        <control-errors [control]="playerForm.get('title')"></control-errors>
                    </m-control-group>
                </div>
                <div class="col-6">
                    <div class="inputs-group">
                        <div class="inputs-group-row"></div>
                    </div>
                </div>
                <div class="col-6">
                    <m-control-group [required]="true" label="First Name">
                        <m-text-control formControlName="firstName"></m-text-control>
                        <control-errors [control]="playerForm.get('firstName')"></control-errors>
                    </m-control-group>
                </div>
                <div class="col-6">
                    <m-control-group [required]="true" label="Last Name">
                        <m-text-control formControlName="lastName"></m-text-control>
                        <control-errors [control]="playerForm.get('lastName')"></control-errors>
                    </m-control-group>
                </div>
                <div class="col-6">
                    <m-control-group [required]="true" label="Date of Birth">
                        <m-dob-control formControlName="dateOfBirth"></m-dob-control>
                        <control-errors [control]="playerForm.get('dateOfBirth')"></control-errors>
                    </m-control-group>
                </div>
                <div class="col-6">
                    <m-control-group [required]="true" label="Sex">
                        <m-gender-control formControlName="gender"></m-gender-control>
                        <control-errors [control]="playerForm.get('gender')"></control-errors>
                    </m-control-group>
                </div>
                <div class="col-6">
                    <m-control-group label="Phone No.">
                        <m-text-control formControlName="phoneNumber"></m-text-control>
                        <control-errors
                            [control]="playerForm.get('phoneNumber')"
                            [errors]="{ pattern: 'The phone number is invalid' }"></control-errors>
                    </m-control-group>
                </div>
                <div class="col-6">
                    <m-control-group [required]="true" label="Email Address">
                        <m-email-control formControlName="email"></m-email-control>
                        <small *ngIf="origin === 'nhs'" class="email-message">
                            Changing your email will not update your NHS account.
                        </small>
                        <control-errors
                            [control]="playerForm.get('email')"
                            [errors]="{
                                pattern: 'The email is invalid',
                                emailMaxLength: 'The email cannot exceed {emailMaxLength} characters'
                            }"></control-errors>
                    </m-control-group>
                </div>
                <div *ngIf="nhsNumber" class="col-6">
                    <m-control-group label="NHS Number">
                        <m-text-control formControlName="nhsNumber"></m-text-control>
                    </m-control-group>
                </div>
            </div>
        </p-fieldset>

        <p-fieldset legend="ADDRESS DETAILS">
            <m-control-group [required]="true" label="Address Line 1">
                <m-text-control formControlName="addressLine1"></m-text-control>
                <control-errors [control]="playerForm.get('addressLine1')"></control-errors>
            </m-control-group>

            <m-control-group label="Address Line 2">
                <m-text-control formControlName="addressLine2"></m-text-control>
                <control-errors [control]="playerForm.get('addressLine2')"></control-errors>
            </m-control-group>

            <m-control-group label="Address Line 3">
                <m-text-control formControlName="addressLine3"></m-text-control>
                <control-errors [control]="playerForm.get('addressLine3')"></control-errors>
            </m-control-group>

            <m-control-group label="Address Line 4">
                <m-text-control formControlName="addressLine4"></m-text-control>
                <control-errors [control]="playerForm.get('addressLine4')"></control-errors>
            </m-control-group>

            <m-control-group [required]="true" label="Post Code">
                <m-text-control formControlName="postcode"></m-text-control>
                <control-errors [control]="playerForm.get('postcode')"></control-errors>
            </m-control-group>

            <div class="inputs-group-row mb-3">
                <patient-consent formControlName="consentToUpdate"> </patient-consent>
            </div>

            <div>
                <div class="container">
                    <button
                        allowOffline
                        pButton
                        class="m-button-primary ml-2 register-button"
                        label="Register"
                        [disabled]="this.playerForm.invalid || savingPlayer"
                        type="submit"></button>

                    <button
                        allowOffline
                        pButton
                        class="p-button-secondary mr-2 clear-cancel-buttons"
                        label="Clear"
                        [disabled]="savingPlayer"
                        (click)="clearForm()"></button>

                    <button
                        allowOffline
                        pButton
                        class="p-button-secondary clear-cancel-buttons"
                        label="Cancel"
                        [disabled]="savingPlayer"
                        (click)="cancelFunc()"></button>
                </div>
            </div>
        </p-fieldset>
    </form>
</div>

<p-dialog
    [(visible)]="nhsLoginDialogVisible"
    [draggable]="false"
    [closable]="false"
    [modal]="true"
    [style]="{ 'max-width': '600px', width: '100%' }"
    [header]="nhsConsentNotGiven ? 'ORB login - Consent to use NHS login Data Denied' : 'NHS login registration'">
    <p-progressBar *ngIf="nhsActionInProgress" mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
    <div class="login-reasons-container">
        <p-message
            *ngIf="nhsActionMessage"
            class="link-nhs-message"
            severity="error"
            [text]="nhsActionMessage"
            [escape]="!nhsConsentNotGiven"></p-message>
        <p-message
            *ngIf="nhsActionSuccessful"
            class="link-nhs-message"
            severity="success"
            text="We have successfully obtained your information from NHS. Please, review & complete the form to finish the registration process.">
        </p-message>
    </div>
    <p-footer>
        <button pButton type="button" label="OK" (click)="closeNhsRegistrationDialog()" *ngIf="!nhsActionInProgress">
            <i class="material-icons">close</i>
        </button>
    </p-footer>
</p-dialog>

<!--
    This Duplicate Patients Dialog used to have the (completed) output set which was
    emitting the selected patient, however, no parent of this component was doing anything with it.

    TODO: Review Duplicate logic at this level?
-->
<duplicate-patients-dialog
    *ngIf="duplicatesDialogVisible"
    [allowSelectExistingPatient]="false"
    [currentPatient]="playerForm.value"
    [duplicates]="duplicatePatients"
    [selfRegistrationUrl]="orgSelfRegistrationURL"
    [(visible)]="duplicatesDialogVisible"
    (proceedInitialAction)="createPlayer(true)"></duplicate-patients-dialog>

<form-event-workflow *ngIf="init" [formEventType]="formEventType" [formEvent]="formEvent" [returnUrl]="'app/cards'"> </form-event-workflow>

<link-nhs-mipro-dialog [(visible)]="linkNhsMiproVisible" [email]="email"></link-nhs-mipro-dialog>

<p-dialog
  header="Linking Your ORB Account"
  [(visible)]="showNHSDialog"
  [modal]="true"
  [closable]="false"
  [baseZIndex]="9999"
  [draggable]="false"
  [resizable]="false"
  [style]="{ 'max-width': '600px', width: '98%' }">
  <p class="p-nhs-email">
    The email address you entered is already associated with a clinician account. Please use a different email for patient registration.
  </p>

  <div class="form-button">
    <button pButton type="button" label="Cancel" class="button-text-center close-button footer-button cancel-button" (click)="onCancel()" rte="7z">
    <i class="material-icons button-icon" rte="7A">close</i>
</button>
</div>
</p-dialog>
